import apiFetch from '../apiFetch'

export default function (token, filter, omit) {
  filter.omit = omit
  return apiFetch({ endPoint: 'DocumentTypeUseTable', method: 'POST', body: filter, token: token, omit: omit })
}
